import _extends from '/app/node_modules/babel-runtime/helpers/extends';
import _defineProperty from '/app/node_modules/babel-runtime/helpers/defineProperty';
import _regeneratorRuntime from '/app/node_modules/babel-runtime/regenerator';
import _asyncToGenerator from '/app/node_modules/babel-runtime/helpers/asyncToGenerator';

var _extends2;

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters, mapState, mapActions } from 'vuex';
import AffiliationsProcess from '~/components/dashboard/affiliations-process';
import AffiliationsWorked from '~/components/dashboard/affiliations-worked';
import DateOption from '~/components/dashboard/date-option';
import mobileWorkedTable from '~/components/shared/worked-mobile-table';
import mobileAffiliationsTable from '~/components/shared/affiliations-mobile-table';
import mobileRankingTable from '~/components/shared/ranking-mobile-table';

export default {
    layout: 'affiliations',
    components: {
        mobileWorkedTable: mobileWorkedTable,
        mobileAffiliationsTable: mobileAffiliationsTable,
        mobileRankingTable: mobileRankingTable,
        DateOption: DateOption
    },
    fetch: function () {
        var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
            var store = _ref.store,
                redirect = _ref.redirect,
                params = _ref.params;
            var type;
            return _regeneratorRuntime.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            type = void 0;

                            if (params.id == "process") {
                                store.commit('dashboard/details/setProcess');
                                store.commit('dashboard/details/setToolbarTitle', 'Affiliation Process');
                                type = "Process";
                                store.commit('dashboard/filters/setTableNameMobile', 'Process');
                                //this.tableName = "Process"
                            } else if (params.id == "worked") {
                                store.commit('dashboard/details/setWorked');
                                store.commit('dashboard/details/setToolbarTitle', 'Affiliation Worked');
                                type = "Work";
                                store.commit('dashboard/filters/setTableNameMobile', 'Work');
                            } else if (params.id == "ranking") {
                                store.commit('dashboard/details/setRanking');
                                store.commit('dashboard/details/setToolbarTitle', 'Affiliation Ranking');
                                type = "Ranking";
                                store.commit('dashboard/filters/setTableNameMobile', 'Ranking');
                            }
                            _context.next = 4;
                            return store.dispatch('dashboard/filters/findProductType');

                        case 4:
                            _context.next = 6;
                            return store.dispatch('dashboard/filters/findAllDepartment');

                        case 6:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, this);
        }));

        function fetch(_x) {
            return _ref2.apply(this, arguments);
        }

        return fetch;
    }(),
    data: function data() {
        var _ref3;

        return _ref3 = {
            pagination: 0,
            loading: false,
            productType: '',
            product: '',
            dateOfAdmission: '',
            department: '',
            province: '',
            district: ''
        }, _defineProperty(_ref3, 'loading', false), _defineProperty(_ref3, 'FilterVisibility', true), _defineProperty(_ref3, 'status', ''), _defineProperty(_ref3, 'statusOptions', [{ text: 'Concreted', value: 0 }, { text: 'Not concreted', value: 1 }]), _defineProperty(_ref3, 'typeOfProduct', ''), _defineProperty(_ref3, 'processShow', this.$store.state.dashboard.details.process), _defineProperty(_ref3, 'workedShow', this.$store.state.dashboard.details.worked), _defineProperty(_ref3, 'rankingShow', this.$store.state.dashboard.details.ranking), _defineProperty(_ref3, 'productsType', this.$store.getters['dashboard/filters/productsType']), _defineProperty(_ref3, 'products', []), _defineProperty(_ref3, 'typeOfSolutions', [{ text: 'Product choice', value: 0 }, { text: 'Validation of RUC / RUS', value: 1 }, { text: 'Representative data', value: 2 }, { text: 'Business data', value: 3 }, { text: 'Hours of service', value: 4 }, { text: 'Installation schedule', value: 5 }, { text: 'Bank account information', value: 6 }, { text: 'Membership requirements', value: 7 }, { text: 'Type of OSV', value: 8 }, { text: 'Affiliation summary', value: 9 }, { text: 'Submission of terms', value: 10 }]), _defineProperty(_ref3, 'tableType', ''), _defineProperty(_ref3, 'departments', this.$store.getters['dashboard/filters/departments']), _defineProperty(_ref3, 'districts', []), _defineProperty(_ref3, 'provinces', []), _defineProperty(_ref3, 'tableName', ''), _defineProperty(_ref3, 'prevData', []), _defineProperty(_ref3, 'newData', []), _defineProperty(_ref3, 'typeOfTable', "Process"), _ref3;
    },

    computed: _extends({}, mapGetters('dashboard/details/', {
        filterComponent: 'setComponent'
    }), mapState({
        affiliationsProcess: function affiliationsProcess(state) {
            return state.dashboard.table.affiliationsProcess || [];
        },
        affiliationsRanking: function affiliationsRanking(state) {
            return state.dashboard.table.affiliationsRanking || [];
        },
        affiliationsWorked: function affiliationsWorked(state) {
            return state.dashboard.table.affiliationsWorked || [];
        }
    })),
    created: function () {
        var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
            return _regeneratorRuntime.wrap(function _callee2$(_context2) {
                while (1) {
                    switch (_context2.prev = _context2.next) {
                        case 0:
                            if (!this.department) {
                                _context2.next = 4;
                                break;
                            }

                            _context2.next = 3;
                            return this.findProvinceByDepartment({ idDepartment: this.department });

                        case 3:
                            this.provinces = _context2.sent;

                        case 4:
                            this.province = '';
                            this.district = '';

                            if (!this.province) {
                                _context2.next = 10;
                                break;
                            }

                            _context2.next = 9;
                            return this.findDistrictByProvince({ idDepartment: this.department, idProvince: this.province });

                        case 9:
                            this.districts = _context2.sent;

                        case 10:
                            this.district = '';

                            if (!this.productType) {
                                _context2.next = 15;
                                break;
                            }

                            _context2.next = 14;
                            return this.findProductByType({ idProductType: this.productType });

                        case 14:
                            this.products = _context2.sent;

                        case 15:
                            this.product = '';

                        case 16:
                        case 'end':
                            return _context2.stop();
                    }
                }
            }, _callee2, this);
        }));

        function created() {
            return _ref4.apply(this, arguments);
        }

        return created;
    }(),

    methods: _extends({
        setDataTable: function setDataTable() {
            if (this.processShow) {
                this.typeOfTable = "Process";
                this.prevData = this.$store.state.dashboard.table.affiliationsProcess;
            } else if (this.workedShow) {
                this.typeOfTable = "Work";
                this.prevData = this.$store.state.dashboard.table.affiliationsWorked;
            } else if (this.rankingShow) {
                this.typeOfTable = "Ranking";
                this.prevData = this.$store.state.dashboard.table.affiliationsRanking;
            }
        },
        updateData: function () {
            var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
                var response;
                return _regeneratorRuntime.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                if (!(this.affiliationsWorked.length !== 0)) {
                                    _context3.next = 12;
                                    break;
                                }

                                _context3.prev = 1;

                                this.pagination += 1;
                                _context3.next = 5;
                                return this.$store.dispatch('dashboard/table/search', {
                                    type: this.typeOfTable,
                                    limit: 10,
                                    paginationNumber: this.pagination,
                                    mutation: 'updateItemsProcess'
                                });

                            case 5:
                                response = _context3.sent;
                                _context3.next = 10;
                                break;

                            case 8:
                                _context3.prev = 8;
                                _context3.t0 = _context3['catch'](1);

                            case 10:
                                _context3.next = 12;
                                break;

                            case 12:
                            case 'end':
                                return _context3.stop();
                        }
                    }
                }, _callee3, this, [[1, 8]]);
            }));

            function updateData() {
                return _ref5.apply(this, arguments);
            }

            return updateData;
        }(),
        scroll: function () {
            var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
                var _this = this;

                return _regeneratorRuntime.wrap(function _callee4$(_context4) {
                    while (1) {
                        switch (_context4.prev = _context4.next) {
                            case 0:
                                // console.log("se lanza el scroll")
                                window.onscroll = function () {
                                    // console.log(document . documentElement . scrollTop)
                                    // console.log(window . innerHeight)
                                    // console.log(document . documentElement . offsetHeight)
                                    // let bottomOfWindow = document . documentElement . scrollTop + window . innerHeight - 20 === document . documentElement . offsetHeight ; 
                                    if (bottomOfWindow) {
                                        _this.loading = true;
                                        _this.updateData();
                                        if (_this.affiliationsWorked.length !== 0) {
                                            _this.newData = _this.newData.concat(_this.affiliationsWorked);
                                        } else {}
                                        _this.loading = false;
                                    }
                                };

                            case 1:
                            case 'end':
                                return _context4.stop();
                        }
                    }
                }, _callee4, this);
            }));

            function scroll() {
                return _ref6.apply(this, arguments);
            }

            return scroll;
        }()
    }, mapActions({
        findProvinceByDepartment: 'dashboard/filters/findProvinceByDepartment',
        findDistrictByProvince: 'dashboard/filters/findDistrictByProvince',
        findProductByType: 'dashboard/filters/findProductByType'
    }), (_extends2 = {
        showFilter: function showFilter() {
            this.$store.commit('dashboard/details/setFilterLayout');
            this.$store.commit('dashboard/details/setFilterComponent');
        },
        search: function search() {
            this.$emit('input');
        },
        dateOptionSelected: function dateOptionSelected(_ref7) {
            var sinceDate = _ref7.sinceDate,
                toDate = _ref7.toDate,
                monthYear = _ref7.monthYear;

            this.sinceDate = sinceDate;
            this.toDate = toDate;
            this.monthYear = monthYear;
            this.search();
        },
        clearFilters: function clearFilters() {
            this.productType = this.product = this.dateOfAdmission = this.department = this.province = this.district = this.status = this.sinceDate = this.toDate = this.monthYear = this.typeOfProduct = null;
            this.$refs.DateOption.clear();
        },
        tableResponsiveData: function tableResponsiveData(prev, neo) {
            // console.log("emitiendo al mutation")
            // console.log(prev)
            // console.log(neo)
            // console.log("emitin")
        },
        selectDepartment: function () {
            var _ref8 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(val) {
                return _regeneratorRuntime.wrap(function _callee5$(_context5) {
                    while (1) {
                        switch (_context5.prev = _context5.next) {
                            case 0:
                                this.$store.commit('dashboard/filters/setIdDepartment', val);

                            case 1:
                            case 'end':
                                return _context5.stop();
                        }
                    }
                }, _callee5, this);
            }));

            function selectDepartment(_x2) {
                return _ref8.apply(this, arguments);
            }

            return selectDepartment;
        }(),
        selectProductType: function () {
            var _ref9 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(val) {
                return _regeneratorRuntime.wrap(function _callee6$(_context6) {
                    while (1) {
                        switch (_context6.prev = _context6.next) {
                            case 0:
                                this.$store.commit('dashboard/filters/setIdProductType', val);

                            case 1:
                            case 'end':
                                return _context6.stop();
                        }
                    }
                }, _callee6, this);
            }));

            function selectProductType(_x3) {
                return _ref9.apply(this, arguments);
            }

            return selectProductType;
        }(),
        selectIdProduct: function () {
            var _ref10 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(val) {
                return _regeneratorRuntime.wrap(function _callee7$(_context7) {
                    while (1) {
                        switch (_context7.prev = _context7.next) {
                            case 0:
                                this.$store.commit('dashboard/filters/setIdProduct', val);

                            case 1:
                            case 'end':
                                return _context7.stop();
                        }
                    }
                }, _callee7, this);
            }));

            function selectIdProduct(_x4) {
                return _ref10.apply(this, arguments);
            }

            return selectIdProduct;
        }(),
        selectTypeofSolution: function () {
            var _ref11 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8(val) {
                return _regeneratorRuntime.wrap(function _callee8$(_context8) {
                    while (1) {
                        switch (_context8.prev = _context8.next) {
                            case 0:
                                this.$store.commit('dashboard/filters/setTypeofSolution', val);

                            case 1:
                            case 'end':
                                return _context8.stop();
                        }
                    }
                }, _callee8, this);
            }));

            function selectTypeofSolution(_x5) {
                return _ref11.apply(this, arguments);
            }

            return selectTypeofSolution;
        }(),
        onSubmit: function () {
            var _ref12 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9() {
                return _regeneratorRuntime.wrap(function _callee9$(_context9) {
                    while (1) {
                        switch (_context9.prev = _context9.next) {
                            case 0:
                                _context9.prev = 0;

                                this.$store.dispatch('dashboard/table/search', {
                                    type: this.$store.state.dashboard.filters.tableNameMobile,
                                    idProduct: Number(this.$store.state.dashboard.filters.IdProduct) || -1,
                                    admisionStartDate: this.$store.state.dashboard.filters.admisionStartDate || '',
                                    admisionEndDate: this.$store.state.dashboard.filters.admisionEndDate || '',
                                    highStartDate: this.$store.state.dashboard.filters.highStartDate || '',
                                    highEndDate: this.$store.state.dashboard.filters.highEndDate || '',
                                    status: -1,
                                    idDepartament: Number(this.idDepartment) || -1,
                                    idProvince: Number(this.$store.state.dashboard.filters.idProvince) || -1,
                                    idDistrict: Number(this.$store.state.dashboard.filters.idDistrict) || -1,
                                    step: Number(this.$store.state.dashboard.filters.idTypeOfSolution) || -1
                                });
                                this.$store.commit('dashboard/details/setFilterComponent');

                                if (!(this.$store.state.dashboard.filters.tableNameMobile === 'Ranking')) {
                                    _context9.next = 7;
                                    break;
                                }

                                return _context9.abrupt('return', this.$store.commit('dashboard/details/setRanking', true));

                            case 7:
                                if (!(this.$store.state.dashboard.filters.tableNameMobile === 'Work')) {
                                    _context9.next = 11;
                                    break;
                                }

                                return _context9.abrupt('return', this.$store.commit('dashboard/details/setWorked', true));

                            case 11:
                                if (!(this.$store.state.dashboard.filters.tableNameMobile === 'Process')) {
                                    _context9.next = 13;
                                    break;
                                }

                                return _context9.abrupt('return', this.$store.commit('dashboard/details/setProcess', true));

                            case 13:
                                _context9.next = 17;
                                break;

                            case 15:
                                _context9.prev = 15;
                                _context9.t0 = _context9['catch'](0);

                            case 17:
                            case 'end':
                                return _context9.stop();
                        }
                    }
                }, _callee9, this, [[0, 15]]);
            }));

            function onSubmit() {
                return _ref12.apply(this, arguments);
            }

            return onSubmit;
        }()
    }, _defineProperty(_extends2, 'search', function () {
        var _ref13 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee10(term) {
            return _regeneratorRuntime.wrap(function _callee10$(_context10) {
                while (1) {
                    switch (_context10.prev = _context10.next) {
                        case 0:
                            this.$store.dispatch('dashboard/table/search', {
                                type: this.$store.state.dashboard.filters.tableNameMobile,
                                term: term
                            });

                        case 1:
                        case 'end':
                            return _context10.stop();
                    }
                }
            }, _callee10, this);
        }));

        function search(_x6) {
            return _ref13.apply(this, arguments);
        }

        return search;
    }()), _defineProperty(_extends2, 'dateAdmin', function dateAdmin() {
        this.$store.commit('dashboard/filters/setDate', 'date admission');
    }), _defineProperty(_extends2, 'dateHight', function dateHight() {
        this.$store.commit('dashboard/filters/setDate', 'date hight');
    }), _extends2)),
    watch: {
        prevData: function prevData() {
            // console.log("dasjfhaksjfkajsg")
        },
        department: function () {
            var _ref14 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee11(id) {
                return _regeneratorRuntime.wrap(function _callee11$(_context11) {
                    while (1) {
                        switch (_context11.prev = _context11.next) {
                            case 0:
                                _context11.next = 2;
                                return this.findProvinceByDepartment({ departmentId: id });

                            case 2:
                                this.provinces = _context11.sent;

                                this.province = '';
                                this.district = '';

                            case 5:
                            case 'end':
                                return _context11.stop();
                        }
                    }
                }, _callee11, this);
            }));

            function department(_x7) {
                return _ref14.apply(this, arguments);
            }

            return department;
        }(),
        province: function () {
            var _ref15 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee12(id) {
                return _regeneratorRuntime.wrap(function _callee12$(_context12) {
                    while (1) {
                        switch (_context12.prev = _context12.next) {
                            case 0:
                                _context12.next = 2;
                                return this.findDistrictByProvince({ departmentId: this.department, provinceId: id });

                            case 2:
                                this.districts = _context12.sent;

                            case 3:
                            case 'end':
                                return _context12.stop();
                        }
                    }
                }, _callee12, this);
            }));

            function province(_x8) {
                return _ref15.apply(this, arguments);
            }

            return province;
        }(),
        productType: function () {
            var _ref16 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee13(id) {
                return _regeneratorRuntime.wrap(function _callee13$(_context13) {
                    while (1) {
                        switch (_context13.prev = _context13.next) {
                            case 0:
                                _context13.next = 2;
                                return this.findProductByType({ productTypeId: id });

                            case 2:
                                this.products = _context13.sent;

                                this.product = '';

                            case 4:
                            case 'end':
                                return _context13.stop();
                        }
                    }
                }, _callee13, this);
            }));

            function productType(_x9) {
                return _ref16.apply(this, arguments);
            }

            return productType;
        }()
    },
    mounted: function mounted() {
        this.setDataTable();
        this.scroll();
        this.newData = this.prevData;
    },
    destroyed: function destroyed() {
        this.scroll(null);
        this.setDataTable(null);
    }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"babelrc":false,"cacheDirectory":true,"presets":[["/app/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/dashboard/_id.vue
// module id = ./node_modules/babel-loader/lib/index.js?{"babelrc":false,"cacheDirectory":true,"presets":[["/app/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/dashboard/_id.vue
// module chunks = 0